import { SizableText, YStack, colors, shadowStandard } from '@my/ui'
import { Frown } from '@tamagui/lucide-icons'

export const EmptyArticles = () => {
  return (
    <YStack gap="$3.5" jc="center" ai="center" py="$6">
      <YStack br={1000} p="$2.5" jc="center" ai="center" bg="$white" {...shadowStandard}>
        <Frown color={colors.primary} width={36} height={36} />
      </YStack>
      <YStack gap="$2" ai="center" jc="center">
        <SizableText textAlign='center' size="$6" color="$overlay12" fow="600">
          Sorry, there’s no articles available at the moment
        </SizableText>
        <SizableText textAlign='center' size="$4" color="$overlay10" fow="500">
          But don’t worry, refresh and try again!
        </SizableText>
      </YStack>
    </YStack>
  )
}
